import React from 'react';
import { PaginaEnum } from '../enums';
import LogService from '../services/LogService';

import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
    makeStyles
} from '@material-ui/core';

import {
    WhatsApp as WhatsAppIcon,
    MailOutline as MailIcon,
    Phone as PhoneIcon
} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    icone: {
        color: theme.palette.primary[200]
    },
    disabled: {
        color: theme.palette.text.disabled
    },
    secondary: {
        color: theme.palette.text.secondary
    },
    link: {
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },
    listItemIcon: {
        minWidth: 35
    }
}));

function ListagemContato() {
    const classes = useStyles();

    return <>
        <List>
            <ListItem component='a'
                href='https://api.whatsapp.com/send?1=pt_BR&phone=5531999101010'
                onClick={() => { LogService.registrarAcesso(PaginaEnum.CONTATOS, PaginaEnum.properties[PaginaEnum.CONTATOS].whatsApp) }}
                target='blank'
                className={classes.link}>
                <ListItemIcon classes={{ root: classes.listItemIcon }}>
                    <WhatsAppIcon className={classes.icone} />
                </ListItemIcon>
                <ListItemText>
                    <Typography variant='subtitle1'
                        className={classes.disabled}>
                        WhatsApp
                        </Typography>
                    <Typography variant='body1'
                        className={classes.secondary}>
                        31 99910-1010
                        </Typography>
                    <Typography variant='caption'
                        className={classes.disabled}>
                        Segunda a sexta de 08:00 às 18:00
                        </Typography>
                </ListItemText>
            </ListItem>
            <ListItem component='a'
                href='mailto:meuatendimento@localiza.com'
                onClick={() => { LogService.registrarAcesso(PaginaEnum.CONTATOS, PaginaEnum.properties[PaginaEnum.CONTATOS].email) }}
                className={classes.link}>
                <ListItemIcon classes={{ root: classes.listItemIcon }}>
                    <MailIcon className={classes.icone} />
                </ListItemIcon>
                <ListItemText>
                    <Typography variant='subtitle1'
                        className={classes.disabled}>
                        E-mail
                        </Typography>
                    <Typography variant='body1'
                        className={classes.secondary}>
                        meuatendimento@localiza.com
                        </Typography>
                </ListItemText>
            </ListItem>
            <ListItem component='a'
                href='tel:08009791010'
                onClick={() => { LogService.registrarAcesso(PaginaEnum.CONTATOS, PaginaEnum.properties[PaginaEnum.CONTATOS].telefone) }}
                className={classes.link}>
                <ListItemIcon classes={{ root: classes.listItemIcon }}>
                    <PhoneIcon className={classes.icone} />
                </ListItemIcon>
                <ListItemText>
                    <Typography variant='subtitle1'
                        className={classes.disabled}>
                        Telefone
                        </Typography>
                    <Typography variant='body1'
                        className={classes.secondary}>
                        0800 099 1001
                        </Typography>
                    <Typography variant='caption'
                        className={classes.disabled}>
                        Todos os dias 24 horas
                        </Typography>
                </ListItemText>
            </ListItem>
        </List>
    </>
}

export default ListagemContato;